// extracted by mini-css-extract-plugin
export default {"bottombox":"BottomNavbar_bottombox__AWUF6","nav_item":"BottomNavbar_nav_item__gd6Yd","nav_icon":"BottomNavbar_nav_icon__39gAj","nav_text":"BottomNavbar_nav_text__u+hJ-"};